export default "__VITE_ASSET__Bp9VvPXo__"